import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { useActiveColorScheme } from "@m/alchemy-theme";
import { Ink } from "../ink/index";
import { Tooltip } from "../tooltip/Tooltip";
import { useWhatInput } from "../hooks/useWhatInput";
import { useCombineRefs } from "../hooks/useCombineRefs";
import * as Styled from "./IconButton.styled";
const defaults = {
    tooltipProps: {}
};
export const IconButton = forwardRef((props, ref) => {
    const { "aria-disabled": ariaDisabled, disabled, hasBackground, icon, onClick, href, palette = "structural", tooltipContents, tooltipProps = defaults.tooltipProps, ...otherProps } = props;
    const buttonRef = useRef(null);
    const { inputType } = useWhatInput();
    const defaultDelay = inputType === "touch" ? 500 : 1000;
    const isDisabled = ariaDisabled || disabled; // TODO: fix this, those props should be both supported, but separate
    const activeColorScheme = useActiveColorScheme();
    const getTrigger = () => {
        const button = (_jsx(Styled.IconButton
        // eslint-disable-next-line react-hooks/rules-of-hooks -- this is only actually called on line 72
        , { 
            // eslint-disable-next-line react-hooks/rules-of-hooks -- this is only actually called on line 72
            ref: useCombineRefs(buttonRef, ref), href: href, 
            // @ts-expect-error i dunno
            as: href ? "a" : undefined, onClick: isDisabled ? undefined : onClick, "aria-disabled": isDisabled, type: "button", palette: palette, "data-testid": "IconButton", activeColorScheme: activeColorScheme, ...otherProps, children: _jsx("div", { children: icon }) }));
        if (hasBackground) {
            return (_jsxs(Styled.IconButtonTriggerWrapper, { children: [button, _jsx(Ink, { opacity: 0.05 })] }));
        }
        return button;
    };
    return (_jsxs(_Fragment, { children: [getTrigger(), tooltipContents && (_jsx(Tooltip, { triggerRef: buttonRef, contents: tooltipContents, mode: "name", delay: defaultDelay, ...tooltipProps }))] }));
});
IconButton.displayName = "IconButton";
IconButton.defaultProps = {
    palette: "structural"
};
